<template>
  <section>
    <button @click.prevent="proccessAndSend(true)">Reset Events And Proccess</button>
    <button @click.prevent="proccessAndSend(false)">Only Proccess New Events</button>
    <h1>Emails From Last Request</h1>
    <hr />
    <EmailList :emails="lastJobEmails" />
    <hr />
    <h1>All Emails</h1>
    <hr />
    <!--<EmailList :emails="allEmails" />-->
    <tol-table class="profile" :table-data="allEmails" :columns="emailColumns">
      <template v-slot:tableHeader>
        <th>{{ $t('app.admin.listing.labels.userEmail') }}</th>
        <th>{{ $t('app.admin.listing.labels.emailSubject') }}</th>
        <th>{{ $t('app.admin.listing.labels.sentAt') }}</th>
        <th>{{ $t('app.admin.listing.labels.message') }}</th>
      </template>

      <template v-slot:message="{ value }">
        <td>
          <a v-if="value.testMessageUrl" :href="value.testMessageUrl">View Email</a>
          <span v-else>No Email</span>
        </td>
      </template>
    </tol-table>
    <Pagination
      :records-per-page="emailsPerPage"
      :offset="currentPage"
      :record-count="emailsCount"
      @change="onChange($event)"
    />
  </section>
</template>
<script>
import Vue from 'vue';
import EmailList from './components/EmailList';

import TolTable from '@/app/components/TolTable';
import Pagination from '@/app/components/Pagination';
import { AdminActions, AdminGetters } from '@/app/features/admin/admin.keys';

export default {
  name: 'Admin',
  components: {
    EmailList,
    TolTable,
    Pagination
  },
  data() {
    return {
      lastJobEmails: [],
      emailColumns: ['toEmail', 'subject', 'sentAt', 'message']
    };
  },
  computed: {
    emailsCount() {
      return this.$store.getters[AdminGetters.EmailLogsCount];
    },
    allEmails() {
      return this.$store.getters[AdminGetters.EmailLogs];
    },
    emailsPerPage() {
      return this.$store.getters[AdminGetters.EmailsPerPage];
    },
    currentPage() {
      return this.$store.getters[AdminGetters.CurrentEmailLogOffset];
    }
  },
  watch: {
    lastJobEmails() {
      this.refreshAllEmails();
    }
  },
  async mounted() {
    await this.refreshAllEmails();
  },
  methods: {
    proccessAndSend(reset = false) {
      Vue.axios.get(`/admin/proccess-events-and-email?reset=${reset}`).then(({ data }) => {
        this.lastJobEmails = data;
      });
    },
    refreshAllEmails() {
      this.$store.dispatch(AdminActions.RetrieveEmailLogs);
    },
    onChange(evt) {
      this.$store.dispatch(AdminActions.SetPaginationParams, evt);
    }
  }
};
</script>
